var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2624_2203)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2624_2203",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.90735e-06H23V23H0V1.90735e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2624_2203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.60774 2.86642L10.8466 0.516467C11.2531 0.291139 11.7469 0.291139 12.1534 0.516467L22.6631 6.34283H0.336914L5.21705 3.63737",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.336914 6.34283H22.6631V7.35358C22.6631 7.91182 22.2106 8.36432 21.6523 8.36432H1.34766C0.789457 8.36432 0.336914 7.91182 0.336914 7.35358V6.34283Z",
    stroke: "url(#paint0_linear_2624_2203)",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.786133 20.6416H22.2139C22.4619 20.6416 22.6631 20.8427 22.6631 21.0908V22.2139C22.6631 22.462 22.4619 22.6631 22.2139 22.6631H0.786133C0.538029 22.6631 0.336914 22.462 0.336914 22.2139V21.0908C0.336914 20.8427 0.538029 20.6416 0.786133 20.6416Z",
    stroke: "url(#paint1_linear_2624_2203)",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7129 3.59351C12.7129 4.26338 12.1699 4.8064 11.5 4.8064C10.8301 4.8064 10.2871 4.26338 10.2871 3.59351C10.2871 2.92363 10.8301 2.38062 11.5 2.38062C12.1699 2.38062 12.7129 2.92363 12.7129 3.59351Z",
    stroke: "url(#paint2_linear_2624_2203)",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3155 20.6416H15.9136L17.2612 18.7447H19.9678L21.3155 20.6416Z",
    stroke: "url(#paint3_linear_2624_2203)",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3155 8.36433H15.9136L17.2612 10.2613H19.9678L21.3155 8.36433Z",
    stroke: "url(#paint4_linear_2624_2203)",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2612 14.4554V10.2613H19.9678V18.7447H17.2612V16.0276",
    stroke: "url(#paint5_linear_2624_2203)",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.08647 20.6416H1.68457L3.03223 18.7447H5.73881L7.08647 20.6416Z",
    stroke: "url(#paint6_linear_2624_2203)",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.08647 8.36433H1.68457L3.03223 10.2613H5.73881L7.08647 8.36433Z",
    stroke: "url(#paint7_linear_2624_2203)",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.73881 18.7447H3.03223V10.2613H5.73881V18.7447Z",
    stroke: "url(#paint8_linear_2624_2203)",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2624_2203",
    x1: 39.4266,
    y1: 6.28057,
    x2: 39.4266,
    y2: 8.42516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E2659"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F42FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2624_2203",
    x1: 39.4266,
    y1: 20.5793,
    x2: 39.4266,
    y2: 22.7239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E2659"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F42FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2624_2203",
    x1: 14.5343,
    y1: 2.3059,
    x2: 14.5343,
    y2: 4.8794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E2659"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F42FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2624_2203",
    x1: 25.3715,
    y1: 18.6863,
    x2: 25.3715,
    y2: 20.6987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E2659"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F42FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2624_2203",
    x1: 25.3715,
    y1: 8.3059,
    x2: 25.3715,
    y2: 10.3184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E2659"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F42FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2624_2203",
    x1: 22,
    y1: 10,
    x2: 22,
    y2: 19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E2659"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F42FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2624_2203",
    x1: 11.1425,
    y1: 18.6863,
    x2: 11.1425,
    y2: 20.6987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E2659"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F42FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2624_2203",
    x1: 11.1425,
    y1: 8.3059,
    x2: 11.1425,
    y2: 10.3184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E2659"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F42FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2624_2203",
    x1: 7.77104,
    y1: 10,
    x2: 7.77104,
    y2: 19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E2659"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F42FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2624_2203"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankicon);
export default __webpack_public_path__ + "static/media/bankicon.b2733d29c8978057a87f3e6647aa15c9.svg";
export { ForwardRef as ReactComponent };